export const OB_SUMMARY_TILE_KEYS = {
  WAVEFORM: "waveform",
  MATERNAL_VITALS: "obvitals",
  CERVICAL_EXAMS: "cervicalexams",
  ANNOTATIONS: "annotations",
  PITOCIN: "pitocin",
  MISC: "other",
};

export const OB_SUMMARY_TILE_ORDER = [
  OB_SUMMARY_TILE_KEYS.MATERNAL_VITALS,
  OB_SUMMARY_TILE_KEYS.CERVICAL_EXAMS,
  OB_SUMMARY_TILE_KEYS.ANNOTATIONS,
  OB_SUMMARY_TILE_KEYS.PITOCIN,
  OB_SUMMARY_TILE_KEYS.MISC,
];

export const OB_SUMMARY_TILE_LABELS = {
  [OB_SUMMARY_TILE_KEYS.MATERNAL_VITALS]: "Maternal Vitals",
  [OB_SUMMARY_TILE_KEYS.CERVICAL_EXAMS]: "Cervical Exams",
  [OB_SUMMARY_TILE_KEYS.ANNOTATIONS]: "Annotations",
  [OB_SUMMARY_TILE_KEYS.PITOCIN]: "Pitocin",
  [OB_SUMMARY_TILE_KEYS.MISC]: "Misc",
};
